<div
  *ngIf="tournament && tournament.lottery_done && isStaff"
>
  <a id="reset_lottery_button" href="javascript:void(0)" (click)="resetLottery()">
    <i class="fa-solid fa-arrows-rotate"></i> Сбросить жеребьевку</a>
</div>
<div *ngIf="tournament && !tournament.lottery_done && isStaff">
    <i class="fa-solid fa-play"></i> Провести жеребьевку:
    <a id="random_lottery_button" href="javascript:void(0)" (click)="lottery()">произвольно</a> /
    по региону:
    <a id="city_lottery_button" href="javascript:void(0)" (click)="lottery('city')">город</a>,
    <a id="region_lottery_button" href="javascript:void(0)" (click)="lottery('region')">регион</a>,
    <a id="country_lottery_button" href="javascript:void(0)" (click)="lottery('country')">страна</a> /
    <a id="calls_lottery_button" href="javascript:void(0)" (click)="lottery('calls')">по званию</a>
</div>
<!--here was *ngIf="tournament && tournament.lottery_done && !tournament.has_groups"-->
<div
  *ngIf="tournament && tournament.lottery_done && isStaff"
>
<!--  here was (click)="createBracket()" -->
  <a id="create_bracket_button" href="javascript:void(0)" (click)="openTournamentTuner()">
    <i class="fa-solid fa-chart-gantt"></i> Сформировать сетку</a>
</div>


<div
  class="row mt-4 mb-4"
  *ngIf="isStaff"
>
    <div class="col">

        <form [formGroup]="searchForm" (submit)="search()">
            <div class="col-md-3 form-group">
                  <div class="input-group">
                      <div class="input-group-prepend">
                          <i class="bi bi-search input-group-text search_item"></i>
                      </div>
                      <input type="text" name="query" id="query" class="form-control input-form-control" #searchInput (input)="search()" formControlName="query" placeholder="Поиск"/>
                  </div>
            </div>
        </form>

        <button class="btn btn-sm btn-primary mt-3" tabindex="-1" (click)="createPlayer()">
            Создать игрока
        </button>
    </div>
  <div *ngIf="isStaff" class="mt-3">
    Заполните поле «телефон» в карточке игрока, чтобы участники могли получать уведомления о начале матчей.<br>
    После этого игрок должен перейти по <a  href="http://t.me/tournamentmaster_bot" target="_blank">
    ссылке</a>, чтобы запустить бота.
  </div>
</div>
<div class="mt-3">
  <a  href="http://t.me/tournamentmaster_bot" target="_blank">
    <i class="fa-brands fa-telegram fa-2xl" style="color: #74c0fc;"></i>
    Запустите Telegram бот, чтобы получать уведомления о начале ваших матчей</a>
</div>
<div class="row mt-4 mb-4">
    <div class="col" *ngIf="searchResults">
        <table class="table table-hover ">
            <thead class="td100">
                <tr>
                    <th
                      scope="col"
                      [class.dir-u]="isSortingByField('search_results', 'full_name', true)"
                      [class.dir-d]="isSortingByField('search_results', 'full_name', false)"
                      (click)="sortBy('search_results', 'full_name')"
                    >
                      <div class="tableHeader" title="Щелкните для сортировки">
                        <div>
                          Участник
                        </div>
                        <div class='sortButtonsSection'>
                          <mat-icon
                            class='smallSortArrow'
                            [ngClass]="highlightTopArrow('search_results', 'full_name')"
                          >
                            expand_less
                          </mat-icon>
                          <mat-icon
                            class='smallSortArrow'
                            [ngClass]="highlightBottomArrow('search_results', 'full_name')"
                          >
                            expand_more
                          </mat-icon>
                        </div>
                      </div>
                    </th>
                    <th
                      scope="col"
                      [class.dir-u]="isSortingByField('search_results', 'birthdate', true)"
                      [class.dir-d]="isSortingByField('search_results', 'birthdate', false)"
                      (click)="sortBy('search_results', 'birthdate')"
                    >
                      <div class="tableHeader" title="Щелкните для сортировки">
                        <div>
                          Г.р.
                        </div>
                        <div class='sortButtonsSection'>
                          <mat-icon
                            class='smallSortArrow'
                            [ngClass]="highlightTopArrow('search_results', 'birthdate')"
                          >
                            expand_less
                          </mat-icon>
                          <mat-icon
                            class='smallSortArrow'
                            [ngClass]="highlightBottomArrow('search_results', 'birthdate')"
                          >
                            expand_more
                          </mat-icon>
                        </div>
                      </div>
                    </th>
                    <th
                      scope="col"
                      [class.dir-u]="isSortingByField('search_results', 'title', true)"
                      [class.dir-d]="isSortingByField('search_results', 'title', false)"
                      (click)="sortBy('search_results', 'title')"
                    >
                      <div class="tableHeader" title="Щелкните для сортировки">
                        <div>
                          Зв.
                        </div>
                        <div class='sortButtonsSection'>
                          <mat-icon
                            class='smallSortArrow'
                            [ngClass]="highlightTopArrow('search_results', 'title')"
                          >
                            expand_less
                          </mat-icon>
                          <mat-icon
                            class='smallSortArrow'
                            [ngClass]="highlightBottomArrow('search_results', 'title')"
                          >
                            expand_more
                          </mat-icon>
                        </div>
                      </div>
                    </th>
                    <th
                      scope="col"
                      [class.dir-u]="isSortingByField('search_results', 'location', true)"
                      [class.dir-d]="isSortingByField('search_results', 'location', false)"
                      (click)="sortBy('search_results', 'location')"
                    >
                      <div class="tableHeader" title="Щелкните для сортировки">
                        <div>
                          Страна, город
                        </div>
                        <div class='sortButtonsSection'>
                          <mat-icon
                            class='smallSortArrow'
                            [ngClass]="highlightTopArrow('search_results', 'location')"
                          >
                            expand_less
                          </mat-icon>
                          <mat-icon
                            class='smallSortArrow'
                            [ngClass]="highlightBottomArrow('search_results', 'location')"
                          >
                            expand_more
                          </mat-icon>
                        </div>
                      </div>
                    </th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody *ngIf="searchResults && searchResults.length">
                <tr *ngFor="let player of getSorted('search_results', searchResults); let i = index" (click)="addPlayer(player)">
                    <td class="td100">
                        <div class="fs14">{{ player.full_name }}</div>
                    </td>
                    <td class="td100">{{ player.birthdate | amDateFormat : 'DD.MM.YYYY' }}</td>
                    <td class="td100">{{ player.title || '' }}</td>
                    <td class="td100">
                        <div class="location" [class.no-icon]="player.city.region.country.a2code" *ngIf="player.city">
                            <span class="fi fi-{{ player.city.region.country.a2code }}" *ngIf="player.city.region.country.a2code"></span>
                            {{ player.city.name }}, {{ player.city.region.name }}, {{ player.city.region.country.name }}
                        </div>
                    </td>
                    <td class="td100">
                        <button class="btn btn-sm btn-primary" (click)="addPlayer(player)">Зарегистрировать</button>
                    </td>
                </tr>
            </tbody>
            <tbody *ngIf="!searchResults || !searchResults.length">
                <tr>
                    <td class="td100 text-center" colspan="5">Игроки не найдены</td>
                </tr>
            </tbody>
        </table>

    </div>
</div>
<!-- here was sort-view class added -->
<table class="table table-hover">
    <thead class="td100">
        <tr>
            <th scope="col">Номер</th>
            <th
              scope="col"
              [class.dir-u]="isSortingByField('players', 'full_name', true)"
              [class.dir-d]="isSortingByField('players', 'full_name', false)"
              (click)="sortBy('players', 'full_name')"
            >
              <div class="tableHeader" title="Щелкните для сортировки">
                <div>
                  Участник
                </div>
                <div class='sortButtonsSection'>
                  <mat-icon
                    class='smallSortArrow'
                    [ngClass]="highlightTopArrow('players', 'full_name')"
                  >
                    expand_less
                  </mat-icon>
                  <mat-icon
                    class='smallSortArrow'
                    [ngClass]="highlightBottomArrow('players', 'full_name')"
                  >
                    expand_more
                  </mat-icon>
                </div>
              </div>
            </th>
            <th
              scope="col"
              [class.dir-u]="isSortingByField('players', 'birthdate', true)"
              [class.dir-d]="isSortingByField('players', 'birthdate', false)"
              (click)="sortBy('players', 'birthdate')"
            >
              <div class="tableHeader" title="Щелкните для сортировки">
                <div>
                  Г.р.
                </div>
                <div class='sortButtonsSection'>
                  <mat-icon
                    class='smallSortArrow'
                    [ngClass]="highlightTopArrow('players', 'birthdate')"
                  >
                    expand_less
                  </mat-icon>
                  <mat-icon
                    class='smallSortArrow'
                    [ngClass]="highlightBottomArrow('players', 'birthdate')"
                  >
                    expand_more
                  </mat-icon>
                </div>
              </div>
            </th>
            <th
              scope="col"
              [class.dir-u]="isSortingByField('players', 'title', true)"
              [class.dir-d]="isSortingByField('players', 'title', false)"
              (click)="sortBy('players', 'title')"
            >
              <div class="tableHeader" title="Щелкните для сортировки">
                <div>
                  Зв.
                </div>
                <div class='sortButtonsSection'>
                  <mat-icon
                    class='smallSortArrow'
                    [ngClass]="highlightTopArrow('players', 'title')"
                  >
                    expand_less
                  </mat-icon>
                  <mat-icon
                    class='smallSortArrow'
                    [ngClass]="highlightBottomArrow('players', 'title')"
                  >
                    expand_more
                  </mat-icon>
                </div>
              </div>
            </th>
            <th
              scope="col"
              [class.dir-u]="isSortingByField('players', 'location', true)"
              [class.dir-d]="isSortingByField('players', 'location', false)"
              (click)="sortBy('players', 'location')"
            >
              <div class="tableHeader" title="Щелкните для сортировки">
                <div>
                  Страна, город
                </div>
                <div class='sortButtonsSection'>
                  <mat-icon
                    class='smallSortArrow'
                    [ngClass]="highlightTopArrow('players', 'location')"
                  >
                    expand_less
                  </mat-icon>
                  <mat-icon
                    class='smallSortArrow'
                    [ngClass]="highlightBottomArrow('players', 'location')"
                  >
                    expand_more
                  </mat-icon>
                </div>
              </div>
            </th>
            <th
              scope="col"
              [class.dir-u]="isSortingByField('players', 'tournament_number', true)"
              [class.dir-d]="isSortingByField('players', 'tournament_number', false)"
              (click)="sortBy('players', 'tournament_number')"
            >
              <div class="tableHeader" title="Щелкните для сортировки">
                <div>
                  Жер.
                </div>
                <div class='sortButtonsSection'>
                  <mat-icon
                    class='smallSortArrow'
                    [ngClass]="highlightTopArrow('players', 'tournament_number')"
                  >
                    expand_less
                  </mat-icon>
                  <mat-icon
                    class='smallSortArrow'
                    [ngClass]="highlightBottomArrow('players', 'tournament_number')"
                  >
                    expand_more
                  </mat-icon>
                </div>
              </div>
            </th>
            <th
              *ngIf="isStaff"
              scope="col"
            ></th>
            <th
              *ngIf="isStaff"
              scope="col"
            ></th>
        </tr>
    </thead>
    <tbody *ngIf="!players">
        <tr>
            <td class="td100 text-center" colspan="7">Загрузка...</td>
        </tr>
    </tbody>
    <tbody *ngIf="players" class="align-middle">
        <tr *ngFor="let player of getSorted('players', players); let i = index">
            <td class="td100">
                #{{ i + 1 }}
            </td>
            <td class="td100 image_with_name">
                <div class="image_with_icon float-start">
                    <span class="fi fi-{{ player.country_code }} image_with_icon__icon" *ngIf="player.country_code"></span>
                    <img src="{{ player.image_url }}" class="image_with_icon__image">
                </div>
                <div class="fs14 image_with_name__name">{{ player.full_name }}</div>
            </td>
            <td class="td100">{{ player.birthdate | amDateFormat : 'DD.MM.YYYY'}}</td>
            <td class="td100">{{ player.title || '' }}</td>
            <td class="td100">
                <div class="location" [class.no-icon]="player.country_code" *ngIf="player.city">
                    <span class="fi fi-{{ player.country_code }}" *ngIf="player.country_code"></span>
                    <div *ngIf="tournament.is_international; then is_international else not_is_international"></div>
                    <ng-template #is_international> {{ player.country }}</ng-template>
                    <ng-template #not_is_international> {{ player.city }}, {{ player.region }}, {{ player.country }}</ng-template>
                </div>
            </td>
            <td class="td100">
                <input
                  type="tel"
                  name="tn-{{player.id}}"
                  id="tn-{{player.id}}"
                  [(ngModel)]="player.tournament_number"
                  (ngModelChange)="updatePlayerTournamentNumber(player)"
                  (keydown)="onEnterHandler($event)"
                  (focus)="onInputFocusHandler(i)"
                  class="form-control"
                  style="width: 60px"
                  disabled="{{!isStaff}}"
                >
<!--                <i class="fa-solid fa-loader" *ngIf="player.saving"></i>-->
            </td>
            <td
              class="td100"
              *ngIf="isStaff"
            >
                <i class="fa-solid fa-circle-xmark text-danger" style="font-size: 18px; cursor: pointer;" (click)="removePlayer(player)"></i>
                <i class="fa-solid fa-edit ms-2 text-primary" style="font-size: 18px; cursor: pointer;"  (click)="editPlayer(player)"></i>
            </td>
        </tr>
    </tbody>
</table>
